import { Divider, Flex, Space, Switch, Typography } from "antd"
import { buildRecurringPaymentText } from "../paymentScheduleModel"
import { hasValue } from "../../../helpers/nullable"
import dayjs from 'dayjs'
import { pluralize } from "../../../helpers/strings"
import { centsToDollarsDisplay } from "../../displayFormatters"
import { RecurringPayment } from "../../../domain/proposals/settings/proposalSettings"

type Props = {
  recurringPayment: RecurringPayment
  perInvoiceAmount?: number
  totalPayments?: number
  showEstimated?: boolean
  onHideScheduleChange: (value: boolean) => void
}

const RecurringPaymentSummary = ({recurringPayment, perInvoiceAmount, totalPayments, showEstimated, onHideScheduleChange}: Props) => {
  const showDivider = !recurringPayment.hideScheduleOnProposal || hasValue(totalPayments) || hasValue(perInvoiceAmount)

  return <div>
    <Space>
      <Switch
        checked={!recurringPayment.hideScheduleOnProposal}
        onChange={value => onHideScheduleChange(!value)}
      />
      Show Invoice Schedule on Proposal
    </Space>
    
    {showDivider && <>
      <Divider style={{margin: '8px 0 8px 0'}} />
      <Flex justify="space-between">
        <div>
          {buildRecurringPaymentText(recurringPayment)}
          <br />
          <Typography.Text type="secondary">
            {!recurringPayment.hideScheduleOnProposal && recurringPayment.estimatedStartDate && `Starting ${dayjs(recurringPayment.estimatedStartDate).format('MMM D, YYYY')}`}
          </Typography.Text>
        </div>
        <div>
          {hasValue(totalPayments) && <Typography.Text type="secondary">{totalPayments} {pluralize(totalPayments, 'payment')}{hasValue(perInvoiceAmount) ? ' of ' : ''}</Typography.Text>}
          {hasValue(perInvoiceAmount) && <>{showEstimated ? 'estimated ' : ''}{centsToDollarsDisplay(perInvoiceAmount)}</>}
        </div>
      </Flex>
    </>}
  </div>
}

export default RecurringPaymentSummary